import { SOURCES } from 'features/new-candidate/constants';
import queryString from 'query-string';
import { decryptId } from 'UI/utils/encrypt';

const firstValue = value => (Array.isArray(value) ? value[0] : value);

const getCompanyId = encryptedId => {
  if (!encryptedId) return null;

  try {
    const [companyId] = decryptId(encryptedId) || [];
    return companyId || null;
  } catch {
    return null;
  }
};

export const getQueryParams = location => {
  if (!location) return null;

  const parsedParams = queryString.parse(location.search);
  const applicantId = firstValue(parsedParams.applicantId);
  const cName = firstValue(parsedParams.cName);
  const encryptedId = firstValue(parsedParams.company);
  const contactId = firstValue(parsedParams.contactId);
  const hiringId = firstValue(parsedParams.hiringId);
  const resumeId = firstValue(parsedParams.resumeId);
  const draftId = firstValue(parsedParams.draftId);

  const companyId = getCompanyId(encryptedId);
  const company = companyId
    ? {
        id: companyId,
        name: cName
      }
    : null;

  const getSource = () => {
    if (companyId) return SOURCES.FROM_SCRATCH;
    if (applicantId) return SOURCES.FROM_TALENT_POOL;
    if (resumeId) return SOURCES.FROM_RESUME;
    if (hiringId || contactId) return SOURCES.FROM_DIRECTORY;
    return null;
  };

  const getId = () => {
    if (applicantId) return applicantId;
    if (resumeId) return resumeId;
    if (hiringId) return hiringId;
    if (contactId) return contactId;
    return null;
  };

  return {
    applicantId,
    company,
    contactId,
    draftId,
    hiringId,
    id: getId(),
    resumeId,
    source: getSource()
  };
};
